<div class="modal-header"><h2 class="modal-title">Part Type(s) Select</h2></div>
<div class="modal-body">
    <dx-form>
        <dxi-item [label]="{ text: 'Part Types' }">
            <div *dxTemplate>
                <dx-list [items]="partTypes"
                         keyExpr="id"
                         [(selectedItemKeys)]="selectedPartTypeIds"
                         selectionMode="multiple"
                         [showSelectionControls]="true"
                         itemTemplate="listItem"
                         class="wrap roles-list">
                    <div *dxTemplate="let item of 'listItem'">
                        {{ item.name }}
                    </div>
                </dx-list>
            </div>
        </dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="add()">Add</button>
    <button type="button" class="btn btn-danger me-3" (click)="delete()">Delete</button>
    <!-- <button type="button" class="btn btn-success" (click)="save()">Save</button> -->
    <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
